export function StatusBadge({ status }) {
  const labels = {
    submitted: 'Submitted',
    approved: 'Approved',
    in_production: 'In Production',
    shipped: 'Shipped',
    delivered: 'Delivered',
    closed: 'Closed',
    cancelled: 'Cancelled',
  };
  return <span className={`badge badge-${status}`}>{labels[status] || status}</span>;
}
